/* HTG — quiz. Question → email → SMS → code.
   Markup: snippets/htg-quiz-body.liquid, wrapped by
     sections/htg-quiz-popup.liquid  (data-mode="popup": store pop-up)
     sections/main-password.liquid   (data-mode="inline": password page card)

   Signups go to Klaviyo's public client endpoint, email consent on step 2
   and SMS consent on step 3 (only while the opt-in box is ticked — it starts
   ticked). Step 2 also posts the Shopify customer form in the background so
   the customer exists in Shopify tagged quiz-popup + quiz-<answer> (+ the
   wrapper's data-tag).

   When the answer carries a product, "Apply & shop" applies the code and
   lands on that product's page.

   localStorage keys (pop-up only): htgQuizDone (finished — never again),
   htgQuizHideUntil (closed — hidden until that timestamp). Finishing the
   password-page quiz sets htgQuizDone too, so nobody is asked twice. */
(function () {
  if (window.__htgQuiz) return;
  window.__htgQuiz = true;

  /* Testing mode: the theme editor, or previewing a theme that is not the
     published one (?preview_theme_id=...). There the pop-up never remembers
     being closed or finished, so it opens every time on scroll / exit —
     otherwise one test run hides it for days and it looks switched off.
     Customers on the published theme get the normal memory. */
  var testing = !!(window.Shopify && (window.Shopify.designMode ||
    (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main')));
  /* ?htgquiz=reset wipes this browser's memory of the pop-up. */
  if (/[?&]htgquiz=reset/.test(location.search)) {
    try { localStorage.removeItem('htgQuizDone'); localStorage.removeItem('htgQuizHideUntil'); } catch (e) {}
  }

  function get(k) { if (testing) return null; try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { if (testing) return; try { localStorage.setItem(k, v); } catch (e) {} }
  function done() { return get('htgQuizDone') === '1'; }
  function snoozed() { return Number(get('htgQuizHideUntil') || 0) > Date.now(); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function e164(raw) {
    var d = String(raw || '').replace(/[^0-9+]/g, '');
    if (!d) return '';
    if (d.charAt(0) === '+') return d;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return '';
  }

  function init(box) {
    if (box.__init) return;
    box.__init = true;

    var inline = box.getAttribute('data-mode') === 'inline';
    var company = box.getAttribute('data-company') || '';
    var listId = box.getAttribute('data-list') || '';
    var source = box.getAttribute('data-source') || 'quiz-popup';
    var extraTag = box.getAttribute('data-tag') || '';
    var delay = Number(box.getAttribute('data-delay')) || 0;
    var scrollPct = Number(box.getAttribute('data-scroll')) || 30;
    var days = Number(box.getAttribute('data-days')) || 3;
    var editor = box.getAttribute('data-editor') === '1';
    var teaser = inline ? null : document.querySelector('[data-htg-quiz-teaser]');
    var state = { answer: null, email: '', lastFocus: null };

    var slides = {};
    box.querySelectorAll('[data-htg-quiz-slide]').forEach(function (el) { slides[el.getAttribute('data-htg-quiz-slide')] = el; });
    var dots = box.querySelectorAll('[data-htg-quiz-dot]');
    var order = { q: 1, email: 2, sms: 3, done: 3 };

    function show(name, noFocus) {
      Object.keys(slides).forEach(function (k) {
        slides[k].hidden = k !== name;
        slides[k].classList.toggle('is-in', k === name);
      });
      dots.forEach(function (d) { d.classList.toggle('is-on', Number(d.getAttribute('data-htg-quiz-dot')) <= order[name]); });
      if (noFocus) return;
      var f = slides[name] && slides[name].querySelector('input:not([type="checkbox"]), [data-htg-quiz-answer], [data-htg-quiz-apply], [data-htg-quiz-copy]');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
      /* Inline: keep the new slide in view on a phone. */
      if (inline && box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    function open() {
      if (inline || !box.hidden) return;
      state.lastFocus = document.activeElement;
      box.hidden = false;
      if (teaser) teaser.hidden = true;
      document.documentElement.style.overflow = 'hidden';
      var cur = Object.keys(slides).filter(function (k) { return !slides[k].hidden; })[0] || 'q';
      show(cur);
    }

    function close() {
      if (inline || box.hidden) return;
      box.hidden = true;
      document.documentElement.style.overflow = '';
      if (!done() && !editor) {
        set('htgQuizHideUntil', String(Date.now() + days * 864e5));
        if (teaser) teaser.hidden = false;
      }
      if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus({ preventScroll: true });
    }

    function finish() {
      if (!editor) set('htgQuizDone', '1');
      if (teaser) teaser.hidden = true;
      fillRec();
      show('done');
    }

    /* ---------- signups ---------- */
    function klaviyo(fields) {
      if (!company || !listId || !window.fetch) return Promise.resolve(false);
      var attrs = { email: fields.email };
      var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      if (fields.phone) {
        attrs.phone_number = fields.phone;
        subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }
      attrs.subscriptions = subs;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).then(function (r) { return r.ok || r.status === 202; }).catch(function () { return false; });
    }

    /* The quiz answer as a profile property, through Klaviyo's own onsite
       script (loaded by the app embed). Kept out of the subscribe call so a
       property problem can never cost the signup. */
    function klaviyoProps(fields) {
      try {
        if (window.klaviyo && window.klaviyo.identify && state.answer) {
          var p = { email: fields.email, quiz_answer: state.answer.label, quiz_tag: state.answer.tag };
          if (fields.phone) p.phone_number = fields.phone;
          window.klaviyo.identify(p);
        }
      } catch (e) {}
    }

    function shopifyCustomer(email) {
      if (!window.fetch) return Promise.resolve();
      var tags = ['quiz-popup'];
      if (state.answer && state.answer.tag) tags.push('quiz-' + state.answer.tag);
      if (extraTag) tags.push(extraTag);
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', tags.join(', '));
      return fetch(root() + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    }

    function busy(form, on) {
      var b = form.querySelector('button[type="submit"]');
      if (b) { b.setAttribute('aria-busy', on ? 'true' : 'false'); b.disabled = !!on; }
    }
    function err(form, msg) { var e = form.querySelector('[data-htg-quiz-err]'); if (e) e.textContent = msg || ''; }

    /* ---------- step 1: answers ---------- */
    box.querySelectorAll('[data-htg-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('[data-htg-quiz-answer]').forEach(function (b) { b.classList.remove('is-picked'); });
        btn.classList.add('is-picked');
        state.answer = {
          tag: btn.getAttribute('data-tag') || '',
          label: btn.getAttribute('data-label') || '',
          title: btn.getAttribute('data-p-title') || '',
          url: btn.getAttribute('data-p-url') || '',
          price: btn.getAttribute('data-p-price') || '',
          img: btn.getAttribute('data-p-img') || '',
          why: btn.getAttribute('data-p-why') || ''
        };
        setTimeout(function () { show('email'); }, 220);
      });
    });

    /* ---------- step 2: email ---------- */
    var emailForm = box.querySelector('[data-htg-quiz-email]');
    if (emailForm) emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = emailForm.querySelector('input[type="email"]');
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err(emailForm, 'Enter a valid email address.'); input.focus(); return; }
      err(emailForm, '');
      busy(emailForm, true);
      state.email = email;
      Promise.all([klaviyo({ email: email }), shopifyCustomer(email)]).then(function () {
        klaviyoProps({ email: email });
        busy(emailForm, false);
        show('sms');
      });
    });

    /* ---------- step 3: sms ---------- */
    var smsForm = box.querySelector('[data-htg-quiz-sms]');
    var optin = box.querySelector('[data-htg-quiz-optin]');
    if (optin) optin.addEventListener('change', function () { if (smsForm) err(smsForm, ''); });
    if (smsForm) smsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (optin && !optin.checked) { err(smsForm, 'Tick the box to get texts, or tap "No thanks" below.'); return; }
      var input = smsForm.querySelector('input[type="tel"]');
      var phone = e164(input.value);
      if (!phone || phone.length < 12) { err(smsForm, 'Enter a 10-digit mobile number.'); input.focus(); return; }
      err(smsForm, '');
      busy(smsForm, true);
      klaviyo({ email: state.email, phone: phone }).then(function () {
        klaviyoProps({ email: state.email, phone: phone });
        busy(smsForm, false);
        finish();
      });
    });
    var skip = box.querySelector('[data-htg-quiz-skip]');
    if (skip) skip.addEventListener('click', finish);

    /* ---------- reward ---------- */
    function fillRec() {
      var a = state.answer, rec = box.querySelector('[data-htg-quiz-rec]');
      if (!a || !a.url) return;
      var code = box.getAttribute('data-code') || '';
      var href = root() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(a.url);
      /* Apply & shop goes straight to the recommended product. */
      var apply = box.querySelector('[data-htg-quiz-apply]');
      if (apply) apply.href = href;
      if (!rec) return;
      var img = box.querySelector('[data-htg-quiz-rec-img]');
      box.querySelector('[data-htg-quiz-rec-why]').textContent = a.why;
      box.querySelector('[data-htg-quiz-rec-name]').textContent = a.title;
      box.querySelector('[data-htg-quiz-rec-price]').textContent = a.price;
      box.querySelector('[data-htg-quiz-rec-link]').href = href;
      if (a.img) { img.src = a.img; img.hidden = false; }
      rec.hidden = false;
    }

    var copyBtn = box.querySelector('[data-htg-quiz-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var code = box.getAttribute('data-code') || '';
      var ok = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, function () {});
    });

    if (inline) return; // the password card needs nothing below

    /* ---------- open / close (pop-up) ---------- */
    box.querySelectorAll('[data-htg-quiz-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(box.querySelectorAll('button, a[href], input'), function (el) { return el.offsetParent !== null && !el.disabled; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (teaser) teaser.addEventListener('click', open);

    /* In the editor, selecting the section (or an answer) opens it straight
       away; the scroll and exit triggers below still run as well. */
    if (editor) {
      document.addEventListener('shopify:section:select', function (e) { if (box.closest('#shopify-section-' + e.detail.sectionId)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (box.closest('#shopify-section-' + e.detail.sectionId)) { box.hidden = true; document.documentElement.style.overflow = ''; } });
      document.addEventListener('shopify:block:select', function (e) { if (box.closest('#shopify-section-' + e.detail.sectionId)) { open(); show('q'); } });
    }

    /* ?htgquiz=1 forces it open, for testing. */
    var forced = /[?&]htgquiz=1/.test(location.search);
    if (done() && !forced) return;
    if (snoozed() && !forced) { if (teaser) teaser.hidden = false; return; }

    /* Auto-open happens once per page view, whichever trigger fires first:
       scroll depth, exit attempt, or the fallback timer. */
    var fired = false;
    var t0 = Date.now();
    function typing() {
      var a = document.activeElement;
      return a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !box.contains(a);
    }
    function autoOpen() {
      if (fired) return;
      if (typing()) { setTimeout(autoOpen, 1500); return; } // never interrupt a form
      fired = true;
      cleanup();
      open();
    }
    if (forced) { setTimeout(autoOpen, 300); return; }

    function room() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }

    /* Scroll depth, plus the mobile exit flick: a fast upward swipe after the
       shopper has read a little way down. Only counted within half a second
       of a touch, so the theme's own smooth scrolls (Buy now, anchor links)
       never set it off. */
    var exitOn = box.getAttribute('data-exit') === '1';
    var lastY = window.scrollY, lastT = Date.now(), touchedAt = 0, maxY = 0;
    function onTouch() { touchedAt = Date.now(); }
    function onScroll() {
      var y = window.scrollY, now = Date.now();
      var r = room();
      if (y > maxY) maxY = y;
      if (r > 0 && y / r * 100 >= scrollPct) { autoOpen(); return; }
      if (exitOn && now - touchedAt < 500 && now - t0 > 4000 && maxY > 600) {
        var dy = y - lastY, dt = Math.max(1, now - lastT);
        if (dy < -80 && -dy / dt > 1.2) { autoOpen(); return; }
      }
      lastY = y; lastT = now;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('touchstart', onTouch, { passive: true });
    window.addEventListener('touchmove', onTouch, { passive: true });

    /* Desktop exit: the pointer leaves through the top edge (tabs, address
       bar, close). Needs a couple of seconds on the page first. */
    function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 2000) autoOpen();
    }
    var finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    if (exitOn && finePointer) document.addEventListener('mouseout', onOut);

    /* Timer: the fallback when set, and the only way in on a page too short
       to scroll. */
    var timer = null;
    if (delay > 0) timer = setTimeout(autoOpen, delay * 1000);
    else setTimeout(function () { if (room() < 200) autoOpen(); }, 8000);

    function cleanup() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('touchstart', onTouch);
      window.removeEventListener('touchmove', onTouch);
      document.removeEventListener('mouseout', onOut);
      if (timer) clearTimeout(timer);
    }
  }

  function boot() { document.querySelectorAll('[data-htg-quiz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
